import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ContactsRoutingModule } from "./contacts-routing.module";
import { SharedModule } from "src/app/shared/shared.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  NgbDropdown,
  NgbDropdownModule,
  NgbPaginationModule,
} from "@ng-bootstrap/ng-bootstrap";
import { CreateContactListComponent } from "./pages/create-contact-list/create-contact-list.component";
import { CreateContactListModalComponent } from "./pages/create-contact-list/components/create-contact-list-modal/create-contact-list-modal.component";
import { GetListsComponent } from "./pages/get-lists/get-lists.component";
import { CreateContactListTableComponent } from "./pages/create-contact-list/components/create-contact-list-table/create-contact-list-table.component";
import { CreateContactListFilterComponent } from "./pages/create-contact-list/components/create-contact-list-filter/create-contact-list-filter.component";
import { DetailedListComponent } from "./pages/detailed-list/detailed-list.component";
import { FeatherModule } from "angular-feather";
import { allIcons } from "angular-feather/icons";
import { DetailedListClientComponent } from "./pages/detailed-list/components/detailed-list-client/detailed-list-client.component";
import { QualifiedListComponent } from "./pages/qualified-list/qualified-list.component";
import { DetailedQualifiedListComponent } from "./pages/qualified-list/components/detailed-qualified-list/detailed-qualified-list.component";
import { AddContactModalComponent } from "./pages/get-lists/components/add-contact-modal/add-contact-modal.component";

@NgModule({
  declarations: [
    CreateContactListComponent,
    CreateContactListModalComponent,
    GetListsComponent,
    CreateContactListTableComponent,
    CreateContactListFilterComponent,
    DetailedListComponent,
    DetailedListClientComponent,
    QualifiedListComponent,
    DetailedListComponent,
    DetailedQualifiedListComponent,
    AddContactModalComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ContactsRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NgbPaginationModule,
    NgbDropdownModule,
    FeatherModule.pick(allIcons),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ContactsModule {}
